import { Box, Button, Typography, Dialog, DialogContent } from '@mui/material';
import { useState, useEffect } from 'react';
import ConfettiAnimation from 'src/components/ConfettiAnimation';

interface IMonitoringSuccessModalProps {
    open: boolean;
    onClose: () => void;
}

export default function MonitoringSuccessModal({ open, onClose }: IMonitoringSuccessModalProps) {
    const [showConfetti, setShowConfetti] = useState(false);

    useEffect(() => {
        if (open) {
            // Запускаем салют при открытии модалки
            setShowConfetti(true);

            // Останавливаем анимацию через 3 секунды
            const timer = setTimeout(() => {
                setShowConfetti(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [open]);

    const handleClose = () => {
        setShowConfetti(false);
        onClose();
    };

    return (
        <>
            {showConfetti && (
                <ConfettiAnimation
                    isPlaying={true}
                    loop={false}
                />
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '24px',
                        padding: 3,
                        textAlign: 'center',
                    },
                }}
            >
                <DialogContent>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={3}
                        py={2}
                    >
                        <Box mb={2}>
                            <Typography
                                textAlign="center"
                                variant="h1"
                                color="primary"
                                sx={{
                                    fontSize: { xs: '32px', sm: '48px' },
                                    fontWeight: 800,
                                    lineHeight: 1.2,
                                }}
                            >
                                Мониторинг успешно запущен
                            </Typography>
                        </Box>

                        <Box mb={2}>
                            <Typography
                                textAlign="center"
                                variant="body1"
                                color="primary"
                                sx={{
                                    fontSize: { xs: '14px', sm: '16px' },
                                    lineHeight: 1.5,
                                }}
                            >
                                Поздравляем! Ваш проект настроен и готов к работе. Круглосуточный мониторинг целевых
                                сообщений в выбранных чатах уже запущен и будет искать лиды для вас 24/7.
                            </Typography>
                        </Box>

                        <Button
                            onClick={handleClose}
                            variant="contained"
                            size="large"
                            fullWidth
                            sx={{
                                mt: 2,
                                maxWidth: 300,
                            }}
                        >
                            Отлично, начать работу
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}
